import { render, staticRenderFns } from "./captcha.vue?vue&type=template&id=f29a9b1c&scoped=true&"
import script from "./captcha.vue?vue&type=script&lang=js&"
export * from "./captcha.vue?vue&type=script&lang=js&"
import style0 from "./captcha.vue?vue&type=style&index=0&id=f29a9b1c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29a9b1c",
  null
  
)

export default component.exports